package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable

@Serializable
data class ProductRegion(
    val id: Long? = null,
    val product: Product? = null,
    val region: Region? = null,
    val sort: Int? = null
)